import React, { useState, useEffect } from "react";
import styled from "styled-components";
import BCWhyVideo from "../assets/BCWhy.mp4";
import mike from "../assets/mike.JPG";
import julia from "../assets/julia.jpeg";
import andy from "../assets/andy-b.jpeg";
import danny from "../assets/danny.JPG";
import will from "../assets/will.JPG";
import mar from "../assets/marzena.jpeg";
import craig from "../assets/craig.png";
import grace from "../assets/grace.JPG";
import adi from "../assets/adi.JPG";
import { FaVolumeDown } from "react-icons/fa";

const WhyPage = () => {
  const [sound, setSound] = useState("muted");
  const [muted, setMuted] = useState(true);

  const handleSound = () => {
    if (sound === "muted") {
      setSound("");
    } else {
      setSound("muted");
    }
  };

  return (
    <Wrapper>
      <div className="whyBCtalk">
        <div className="content">
          <h2>Why learn Bachata</h2>
          <p className="subtitle">In their own words…</p>
          <p className="narrative">
            For us, Julia explains that Bachata is a great form of exercise,
            really helps with mental health, and brings people together. There’s
            always such a happy, positive vibe — and it’s a beautiful way to
            connect, communicate, and build a supportive community.
          </p>
        </div>
        <div className="videocontainer">
          <video src={BCWhyVideo} autoPlay loop muted={muted} playsInline />

          <button
            className="control"
            onClick={() => setMuted((m) => !m)}
            aria-label={muted ? "Unmute video" : "Mute video"}
          >
            <FaVolumeDown />
          </button>
        </div>
      </div>
      <h2>
        Learn about our amazing dance instructors and what they can offer...
      </h2>
      <div className="teacher left">
        <div className="teacher__image-container">
          <img src={julia} alt="Julia - Teacher " className="teacher__image" />
        </div>
        <div className="teacher___info">
          <h1 className="teacher__name">Julia Sulimenko</h1>
          <p>
            My name is Julia and my passion for dance started at a young age and
            has only grown over the years. I’ve trained in various styles,
            including Contemporary, Latin Ballroom, Argentine Tango, and Belly
            Dance, but my heart belongs to Salsa, Bachata, and Latin music. With
            vast experience performing at various events, entering competitions,
            and auditioning for dance productions, I have honed my skills both
            on stage and in the studio. Teaching and performing have been a
            major part of my journey, and in January 2023, I founded Bachata
            Connection—a hub for all things Bachata. As a Bachata Ambassador on
            the South Coast of England, I love sharing my passion by organizing
            events and building a vibrant dance community. Dance is my energy,
            my joy, and an essential part of my life—I couldn’t imagine it any
            other way!
          </p>
        </div>
      </div>
      <div className="teacher right">
        <div className="teacher__image-container">
          <img src={andy} alt="Andy - Teacher " className="teacher__image" />
        </div>
        <div className="teacher___info">
          <h1 className="teacher__name">Andy Barnetson</h1>
          <p>
            My name is Andy and I am one of the Bachata Connection founders and
            teacher. I love teaching and it is rewarding to see students'
            progress and development. I have been dancing for many years; I
            started with Salsa and continued my dance journey, mastering Sensual
            Bachata. Dancing became an important part of my life - it is great
            for socialising as well as helps with stress and anxiety.
          </p>
        </div>
      </div>
      <div className="teacher left">
        <div className="teacher__image-container">
          <img src={mike} alt="Mike - Teacher " className="teacher__image" />
        </div>
        <div className="teacher___info">
          <h1 className="teacher__name">Mike Whitbread</h1>
          <p>
            I've been part of the Latin dance scene for nearly 20 years, and
            it's truly where my heart is. For over a decade, I've had the joy of
            DJing up and down the South West coast, connecting with dancers and
            sharing the music I love. One of the highlights of my journey so far
            was being invited to DJ in Ibiza in 2023 as part of the StepUp team.
            Beyond DJing, I also teach Salsa and Bachata. There's something
            really special about helping people find their rhythm and confidence
            on the dance floor, no matter their level. What I love most is
            creating a vibe that keeps people moving and smiling all night long.
            I mix classics with the latest tracks, always tuning into the
            crowd’s energy and making sure the party stays alive. For me, it’s
            all about connection—through music, movement, and shared moments on
            the floor.
          </p>
        </div>
      </div>
      <div className="teacher right">
        <div className="teacher__image-container">
          <img src={danny} alt="Danny - Teacher " className="teacher__image" />
        </div>
        <div className="teacher___info">
          <h1 class="teacher__name">Danny Romero</h1>
          <p>
            My name is Danny and dance is more than just a passion for me—it’s a
            way of life. Bachata and Salsa are at the heart of my journey, but
            I’ve also explored Argentine Tango, Kizomba, Brazilian Zouk,
            Ballroom Latin, and more. Each style has deepened my connection to
            music, movement, and culture, making my dance journey incredibly
            fulfilling. Throughout the years, dancing has brought me not only
            joy but also incredible experiences and connections with amazing
            people. The energy, rhythm, and expression that dance offers make it
            an essential part of who I am, and I can’t imagine life without it!
          </p>
        </div>
      </div>
      <div className="teacher left ">
        <div className="teacher__image-container">
          <img src={will} alt="William - Teacher " className="teacher__image" />
        </div>
        <div className="teacher___info">
          <h1 class="teacher__name">William Hernandez Abreu </h1>
          <p>
            Born in Havana, Cuba, I have been dancing since childhood. I
            graduated from the renowned José María Romero Escuela Nacional de
            Show Arts & Espectáculos and have performed internationally in Cuba,
            Spain, Poland, and the UK. My experience includes Cuban television,
            top theatres like Teatro América and Karl Marx Theatre, and
            collaborations with artists such as Charanga Habanera, Pablo FG, and
            Dan Den Grupo. Cuban Salsa is my passion—it's more than just a
            dance; it's a way of life. I love sharing its energy, rhythm, and
            cultural roots, whether through teaching, performing, or DJing.
            Expanding into music production, I blend Afro-Cuban influences with
            Salsa, Bachata, Reggaeton, R&B, Hip Hop, and Deep House. As DJ
            Pupito, I have played at international venues and regularly perform
            across the UK, including London, Bristol, Cardiff, Brighton, and the
            Isle of Wight.
          </p>
        </div>
      </div>
      <div className="teacher right">
        <div className="teacher__image-container">
          <img src={mar} alt="Marzena - Teacher " className="teacher__image" />
        </div>
        <div className="teacher___info">
          <h1 class="teacher__name">Marzena Bober</h1>
          <p>
            My name is Marzena, and I’m passionate about dance, fitness, and
            beauty! Dancing has been a part of my life since I was eight,
            allowing me to express emotions, connect with others, and find joy
            in movement. I started with Salsa and ballroom dance in Poland,
            where I had the privilege of assisting my teacher at a young age,
            sparking my love for teaching. Today, I specialize in Salsa,
            Bachata, Lady Styling, and Sensual Dance, helping my students build
            confidence, embrace self-expression, and experience the joy of
            dance. I also draw inspiration from Contemporary Dance, Jazz, and
            Kizomba, constantly growing as a dancer and instructor. My goal is
            to create a welcoming space where everyone can feel the magic of
            movement and discover their own unique dance journey.
          </p>
        </div>
      </div>
      <div className="teacher left">
        <div className="teacher__image-container">
          <img src={craig} alt="Craig - Teacher " className="teacher__image" />
        </div>
        <div className="teacher___info">
          <h1 class="teacher__name">Craig Eldridge</h1>
          <p>
            I started dancing salsa in 2004 — actually, as the result of a
            drunken bet I lost! But it didn’t take long for me to realise how
            much I genuinely enjoyed it. After some intense learning, I began
            teaching for Just Dance Salsa in 2005 and have been sharing my love
            for the dance ever since. I focus on developing a strong lead,
            keeping footwork small and clean, and most importantly, dancing to
            the music rather than just doing moves. Teaching beginners has
            always been my passion. I love helping people discover the same
            excitement and joy I felt when I first started salsa. My approach is
            fun and laid-back — I’d rather have people laugh with (and sometimes
            at) me than worry about how scary or embarrassing salsa might feel
            the first time.
          </p>
        </div>
      </div>
      <div className="teacher right">
        <div className="teacher__image-container">
          <img src={grace} alt="Grace - Teacher " className="teacher__image" />
        </div>
        <div className="teacher___info">
          <h1 class="teacher__name">Grace Silliton</h1>
          <p>
            I’ve been dancing salsa from a young age, inspired by my father, who
            is also a dance teacher. At 16, I began assisting at his salsa club,
            and that’s where I discovered my love for teaching. Since then, I’ve
            had the opportunity to teach at some of London’s most prestigious
            dance schools, including the Latin Dance Academy and Caramelo Latin
            Dance. Dancing has also taken me across Europe, where I’ve guest
            taught and performed at various dance congresses, as well as
            competed in international competitions. My love for salsa and
            bachata shines through in my teaching style. I’m passionate about
            sharing strong technique, styling, and—most importantly—the power of
            connection, always with an emphasis on having fun on the dance
            floor.
          </p>
        </div>
      </div>
      <div className="teacher left">
        <div className="teacher__image-container">
          <img src={adi} alt="Adi - Teacher " className="teacher__image" />
        </div>
        <div className="teacher___info">
          <h1 className="teacher__name">Adi Boriceanu</h1>
          <p>
            I have over 10 years of experience in dance, and for me, dance is
            not just a passion — it is a part of my life. I started my journey
            in Romania with Ballroom dancing for one year, and then I continued
            with Latin dance, where I truly found my rhythm and expression. Over
            the years, I have participated in many competitions and proudly
            achieved several podium placements. I enjoy the challenge of
            competing, but my greatest opponent has always been myself — the
            person I was yesterday. My motto is simple: “Add dance to your life
            and your body will thank you later.”
          </p>
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  padding-bottom: 2rem;
  padding-top: 2rem;
  background-color: var(--clr-bcgrey);

  h2 {
    text-align: center;
    margin: 0 auto;
    max-width: 1500px;
    display: block;
    color: var(--clr-primary-1);
    margin-bottom: 1rem;
  }
  .subtitle {
    font-style: italic;
    color: #888;
    margin-bottom: 0.5rem;
  }

  .narrative {
    font-size: 1.05rem;
    line-height: 1.7;
  }

  .content {
    display: block;
    margin: 1rem 1rem;

    border-radius: 4px;
  }

  .content p {
    color: #6b6b6b;
    line-height: 1.6;
    margin-bottom: 0;
  }

  .whyBCtalk {
  }

  video {
    width: 100%;
    height: 33vh;
    object-fit: cover;
    position: relative;
    background-size: cover;
  }
  .teacher__image-container {
    display: inline-block;
    vertical-align: middle;
    width: 100%;
  }
  .teacher__image {
    width: 100%;
    vertical-align: top;
  }
  .teacher {
    max-width: 1200px;
    margin: 2rem auto;
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
    padding: 0 1rem;
  }

  @media (min-width: 900px) {
    .teacher {
      grid-template-columns: 420px 1fr;
      align-items: center;
    }
    .teacher.right .teacher__image-container {
      order: 2;
    }

    .teacher.right .teacher___info {
      order: 1;
    }
  }

  .teacher___info p {
    color: #6b6b6b;
    line-height: 1.6;
    margin-bottom: 0;
  }
  .teacher.right {
    margin-bottom: 2rem;
  }

  .teacher.left {
    margin-bottom: 2rem;
  }
  .teacher-container {
    background-color: var(--clr-bclghtgrey);
    /* padding: 2rem; */
    /* max-width: 1200px; */
    border-radius: 4px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  .teacher__name {
    margin: 0.2rem;
    color: var(--clr-primary-1);
    font-size: 2rem;
  }

  .teacher.right > .teacher___info {
    text-align: left;
  }

  .videocontainer {
    position: relative;
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  }
  .control {
    position: absolute;
    bottom: 12px;
    left: 12px;
    width: 44px;
    height: 44px;
    border-radius: 999px;
    border: 0;
    background: rgba(255, 255, 255, 0.85);
    display: grid;
    place-items: center;
  }

  .control:focus-visible {
    outline: 3px solid var(--clr-primary-2);
  }

  @media (min-width: 40rem) {
    .content {
      margin: 1rem 0rem;
      border-radius: 4px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      background-color: var(--clr-bclghtgrey);
      padding: 2rem;
    }

    .content h2 {
    }
    .whyBCtalk {
      max-width: 1500px;
      display: flex;
      flex-direction: column;
      padding: 2rem;
      margin: 0rem auto;
    }

    .content p {
      padding: 0;
    }

    h2 {
      max-width: 1500px;
      display: flex;
      margin-left: 2rem;
    }

    video {
      display: block;
      width: 100%;
      height: clamp(240px, 50vh, 520px);
      object-fit: cover;
    }

    .teacher.left {
      margin: 3rem auto;
      max-width: 1500px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      /* background-color: var(--clr-bclghtgrey);
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); */
    }

    .teacher__image-container {
      display: inline-block;
      vertical-align: middle;
      width: 30rem;
      box-shadow: 3px 3px 3px 3px rgba(0, 0, 0, 0.3);
    }

    .teacher__image {
      width: 100%;
      vertical-align: top;
    }
    .teacher__name {
      margin: 0.2rem;
      color: var(--clr-primary-1);
      font-size: 2rem;
    }

    .teacher___info {
      text-align: right;
      padding: 0.9rem;
      display: inline-block;
      width: 40rem;
      padding: 2rem;
      border-radius: 4px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      background-color: var(--clr-bclghtgrey);
      margin: 1rem;
    }
    .teacher.right {
      margin: 3rem auto;
      max-width: 1500px;
      display: flex;
      align-items: center;
      justify-content: space-around; /*
      background-color: var(--clr-bclghtgrey); */
    }

    .teacher.right > .teacher___info {
      text-align: left;
    }
  }
`;
export default WhyPage;
